
export const reorderItemInArray = (array: any[], oldIndex: number, newIndex: number) => {
  const res = [...array];
  const element = res[oldIndex];
  res.splice(oldIndex, 1);
  res.splice(newIndex, 0, element);
  return res;
};
